import React from "react";
import "./ncInput.css";

const NcInput = ({ name, label, error, ...rest }) => {
  return (
    <ul className="ncFormList">
      <li className="ncFormList_row">
        <label>{label}</label>
        <input {...rest} name={name} id={name} className="ncInput" />
        {error && <div className="alert alert-danger">{error}</div>}
      </li>
    </ul>
  );
};

export default NcInput;
